
import { createClient } from '@supabase/supabase-js';

// Use the environment variables that match your .env file
const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || '';

// Only create Supabase client if we have valid credentials
export const supabase = supabaseUrl && supabaseAnonKey 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : createClient('https://placeholder.supabase.co', 'placeholder-key');

// SQL schema for easy migration to self-hosted Postgres
export const SCHEMA_SQL = `
-- Episodes table
CREATE TABLE IF NOT EXISTS episodes (
  id SERIAL PRIMARY KEY,
  title VARCHAR(255) NOT NULL,
  description TEXT NOT NULL,
  guest VARCHAR(255) NOT NULL,
  guest_linkedin VARCHAR(500),
  guest2 VARCHAR(255),
  guest_linkedin2 VARCHAR(500),
  guest3 VARCHAR(255),
  guest_linkedin3 VARCHAR(500),
  guest4 VARCHAR(255),
  guest_linkedin4 VARCHAR(500),
  guest5 VARCHAR(255),
  guest_linkedin5 VARCHAR(500),
  notes TEXT,
  show_notes TEXT,
  transcript TEXT,
  resource1_name VARCHAR(255),
  resource1_url VARCHAR(500),
  resource2_name VARCHAR(255),
  resource2_url VARCHAR(500),
  resource3_name VARCHAR(255),
  resource3_url VARCHAR(500),
  related_episodes TEXT,
  category VARCHAR(100) NOT NULL,
  category2 VARCHAR(100),
  category3 VARCHAR(100),
  category4 VARCHAR(100),
  category5 VARCHAR(100),
  audio_url VARCHAR(500) NOT NULL,
  duration VARCHAR(50) NOT NULL,
  date DATE NOT NULL,
  advertising_image VARCHAR(500) NOT NULL,
  view_count INTEGER DEFAULT 0,
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  updated_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- Categories table
CREATE TABLE IF NOT EXISTS categories (
  id SERIAL PRIMARY KEY,
  name VARCHAR(100) UNIQUE NOT NULL,
  description TEXT,
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- Industries table
CREATE TABLE IF NOT EXISTS industries (
  id SERIAL PRIMARY KEY,
  name VARCHAR(100) UNIQUE NOT NULL,
  description TEXT,
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- Subscribers table
CREATE TABLE IF NOT EXISTS subscribers (
  id SERIAL PRIMARY KEY,
  name VARCHAR(255) NOT NULL,
  email VARCHAR(255) UNIQUE NOT NULL,
  country VARCHAR(3) NOT NULL,
  industry VARCHAR(100),
  subscription_date TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  registration_date DATE DEFAULT CURRENT_DATE,
  last_access DATE DEFAULT CURRENT_DATE,
  total_views INTEGER DEFAULT 0,
  episode_views JSONB DEFAULT '{}',
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  updated_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- Episode views table for analytics
CREATE TABLE IF NOT EXISTS episode_views (
  id SERIAL PRIMARY KEY,
  episode_id INTEGER REFERENCES episodes(id) ON DELETE CASCADE,
  subscriber_id INTEGER REFERENCES subscribers(id) ON DELETE SET NULL,
  view_date DATE DEFAULT CURRENT_DATE,
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- Function to increment episode views
CREATE OR REPLACE FUNCTION increment_episode_views(episode_id INTEGER)
RETURNS void AS $$
BEGIN
  UPDATE episodes SET view_count = view_count + 1 WHERE id = episode_id;
  INSERT INTO episode_views (episode_id) VALUES (episode_id);
END;
$$ LANGUAGE plpgsql;

-- Indexes for better performance
CREATE INDEX IF NOT EXISTS idx_episodes_date ON episodes(date DESC);
CREATE INDEX IF NOT EXISTS idx_episodes_category ON episodes(category);
CREATE INDEX IF NOT EXISTS idx_episode_views_episode_id ON episode_views(episode_id);
CREATE INDEX IF NOT EXISTS idx_subscribers_email ON subscribers(email);
CREATE INDEX IF NOT EXISTS idx_subscribers_subscription_date ON subscribers(subscription_date DESC);

-- Row Level Security (RLS) policies
ALTER TABLE episodes ENABLE ROW LEVEL SECURITY;
ALTER TABLE categories ENABLE ROW LEVEL SECURITY;
ALTER TABLE industries ENABLE ROW LEVEL SECURITY;
ALTER TABLE subscribers ENABLE ROW LEVEL SECURITY;
ALTER TABLE episode_views ENABLE ROW LEVEL SECURITY;

-- Allow read access to episodes, categories, industries for everyone
CREATE POLICY "Public read access" ON episodes FOR SELECT USING (true);
CREATE POLICY "Public read access" ON categories FOR SELECT USING (true);
CREATE POLICY "Public read access" ON industries FOR SELECT USING (true);

-- Allow insert/update for episodes, categories, industries (admin only in production)
CREATE POLICY "Admin write access" ON episodes FOR ALL USING (true);
CREATE POLICY "Admin write access" ON categories FOR ALL USING (true);
CREATE POLICY "Admin write access" ON industries FOR ALL USING (true);

-- Subscriber data should be protected
CREATE POLICY "Subscriber own data" ON subscribers FOR ALL USING (auth.uid()::text = email);
CREATE POLICY "Episode views tracking" ON episode_views FOR INSERT WITH CHECK (true);
`;
